import React from "react";
import { ActionIcon, Indicator } from "@mantine/core";
import { IconMessageCircle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useChat } from "./ChatContext";

export default function ChatWidget() {
  const { t } = useTranslation();
  const { unreadCount, toggleTray } = useChat();
  const badge = unreadCount > 99 ? "99+" : String(unreadCount);

  return (
    <Indicator
      color="red"
      offset={4}
      size={16}
      label={badge}
      disabled={unreadCount < 1}
    >
      <ActionIcon
        size={40}
        variant="light"
        radius="xl"
        onClick={toggleTray}
        aria-label={t("chat")}
      >
        <IconMessageCircle size={20} />
      </ActionIcon>
    </Indicator>
  );
}
